import {
  Component,
  OnInit,
  ViewChild,
  AfterViewInit,
  Input,
  ElementRef,
  Inject,
} from "@angular/core";
import { OnboardingService } from "../../shared/service/onboarding.service";
import { ExitInterviews } from "../../shared/models/ExitInterviews";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatSortHeader, MatSort, MatDialog, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { Router } from "@angular/router";
import {
  ConfirmDialogModel,
  ConfirmDialogComponent,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { UserService } from "../../shared/service/user.service";
import { EmployeeService } from "../../shared/service/employee.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-exit-add-dialog",
  templateUrl: "./exit-add-dialog.component.html",
  styleUrls: ["./exit-add-dialog.component.css"],
})
export class ExitAddDialogComponent {
  question: string;

  constructor(
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<ExitAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    if (!this.question || this.question.trim() === "") {
      this.toastr.error("Please enter the question here"); 
    } else {
      this.dialogRef.close(this.question);
    }
  }
}

